/**
 * Minutos desde medianoche para ordenar por hora.
 * Acepta "09:00", "9:00-10:00", "10:00 – 11:30", etc. (usa la primera hora encontrada).
 * Sin hora válida → al final del listado.
 */
export function parseHoraSortKey(hora) {
  const s = String(hora ?? "").trim();
  if (!s) return Number.POSITIVE_INFINITY;
  const m = s.match(/(\d{1,2})[:.](\d{2})/);
  if (!m) return Number.POSITIVE_INFINITY;
  const h = parseInt(m[1], 10);
  const min = parseInt(m[2], 10);
  if (!Number.isFinite(h) || !Number.isFinite(min) || h < 0 || h > 23 || min < 0 || min > 59) {
    return Number.POSITIVE_INFINITY;
  }
  return h * 60 + min;
}

function sortByHora(items, getHora) {
  const list = Array.isArray(items) ? items : [];
  return list
    .map((item, index) => ({
      item,
      index,
      key: parseHoraSortKey(getHora(item)),
    }))
    .sort((a, b) => {
      if (a.key !== b.key) return a.key - b.key;
      return a.index - b.index;
    })
    .map(({ item }) => item);
}

export function sortActividadesPorHora(actividades) {
  return sortByHora(actividades, (a) => a?.hora);
}

export function sortFranjasPorHora(franjas) {
  return sortByHora(franjas, (f) => f?.hora).map((f, i) => ({
    ...f,
    orden: i,
  }));
}

export function withProgramaDiasSortedPorHora(dias) {
  if (!Array.isArray(dias)) return [];
  return dias.map((dia) => ({
    ...dia,
    actividades: sortActividadesPorHora(dia?.actividades),
  }));
}

export function withTalleresDiasSortedPorHora(dias) {
  if (!Array.isArray(dias)) return [];
  return dias.map((dia) => ({
    ...dia,
    franjas: sortFranjasPorHora(dia?.franjas),
  }));
}
